"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FPaymentsService = void 0;
const __1 = require("../../..");
const Sentry = __importStar(require("@sentry/react"));
const domain_1 = require("../../../domain");
const mappers_1 = require("../mappers");
const __2 = require("..");
class FPaymentsService {
    constructor(apolloClient) {
        this.apolloClient = apolloClient;
    }
    getPaymentRequest(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const mercanetResponseMapper = new mappers_1.MercanetResponseMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: __1.GET_PAYMENT_REQUEST,
                    variables,
                });
                return Promise.resolve(mercanetResponseMapper.toDomain(response));
            }
            catch (error) {
                return Promise.reject(new domain_1.PaymentServiceErrors.GetPaymentRequestError("GET_PAYMENT_REQUEST_FAILED", error));
            }
        });
    }
    getPaymentStatus(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const mercanetResponseStatusMapper = new mappers_1.MercanetResponseStatusMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: __1.GET_PAYMENT_STATUS,
                    variables,
                });
                return Promise.resolve(mercanetResponseStatusMapper.toDomain(response));
            }
            catch (error) {
                return Promise.reject(new domain_1.PaymentServiceErrors.GetPaymentStatusError("GET_PAYMENT_STATUS_FAILED", error));
            }
        });
    }
    getEdenredAuthorizationURL(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const edenredAuthorizationURLMapper = new mappers_1.EdenredAuthorizationURLMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: __2.GET_EDENRED_AUTHORIZATION_URL,
                    variables,
                });
                return Promise.resolve(edenredAuthorizationURLMapper.toDomain(response));
            }
            catch (error) {
                return Promise.reject(new domain_1.PaymentServiceErrors.GetEdenredAuthorizationURLRequestError("GET_EDENRED_AUTHORIZATION_URL_REQUEST_FAILED", error));
            }
        });
    }
    getEdenredDailyBalance(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const edenredDailyBalanceMapper = new mappers_1.EdenredDailyBalanceMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: __2.GET_EDENRED_DAILY_BALANCE,
                    variables,
                    fetchPolicy: "no-cache",
                });
                return Promise.resolve(edenredDailyBalanceMapper.toDomain(response));
            }
            catch (error) {
                return Promise.reject(new domain_1.PaymentServiceErrors.GetEdenredDailyBalanceRequestError("GET_EDENRED_DAILY_BALANCE_REQUEST_FAILED", error));
            }
        });
    }
    generateEdenredTokens(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const generateEdenredTokensMapper = new mappers_1.GenerateEdenredTokensMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: __2.GENERATE_EDENRED_TOKENS,
                    variables,
                });
                return Promise.resolve(generateEdenredTokensMapper.toDomain(response));
            }
            catch (error) {
                return Promise.reject(new domain_1.PaymentServiceErrors.GenerateEdenredTokensRequestError("GENERATE_EDENRED_TOKENS_REQUEST_FAILED", error));
            }
        });
    }
    payOrderWithCard(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const payOrderWithCardResponseMapper = new mappers_1.PayOrderWithCardResponseMapper();
                const response = yield this.apolloClient.query({
                    query: __1.PAY_ORDER_WITH_CARD,
                    variables,
                });
                return Promise.resolve(payOrderWithCardResponseMapper.toDomain(response));
            }
            catch (error) {
                // todo - receive info if user has badg (idGuest) or not, to add it into logging context
                Sentry.captureException(error, {
                    tags: { request: "PAY_ORDER_WITH_CARD" },
                    extra: {
                        idOrder: variables.idOrder,
                        context: "Error while paying order with credit card",
                    },
                });
                return Promise.reject(new domain_1.PaymentServiceErrors.PayOrderWithCardError("PAY_ORDER_WITH_CARD_REQUEST_FAILED", error));
            }
        });
    }
    getAxeptaPaymentRequest(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const axeptaResponseMapper = new mappers_1.AxeptaResponseMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: __1.GET_AXEPTA_PAYMENT_REQUEST,
                    variables,
                });
                return Promise.resolve(axeptaResponseMapper.toDomain(response));
            }
            catch (error) {
                return Promise.reject(new domain_1.PaymentServiceErrors.GetAxeptaPaymentRequestError("GET_AXEPTA_PAYMENT_REQUEST_FAILED", error));
            }
        });
    }
    getAxeptaPaymentStatus(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const axeptaResponseStatusMapper = new mappers_1.AxeptaResponseStatusMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: __1.GET_AXEPTA_PAYMENT_STATUS,
                    variables,
                });
                return Promise.resolve(axeptaResponseStatusMapper.toDomain(response));
            }
            catch (error) {
                return Promise.reject(new domain_1.PaymentServiceErrors.GetPaymentStatusError("GET_AXEPTA_PAYMENT_STATUS_FAILED", error));
            }
        });
    }
    payOrderWithCardAxepta(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const mapper = new mappers_1.PayOrderWithCardAxeptaResponseMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: __1.PAY_ORDER_WITH_CARD_AXEPTA,
                    variables,
                });
                return Promise.resolve(mapper.toDomain(response));
            }
            catch (error) {
                Sentry.captureException(error, {
                    tags: { request: "PAY_ORDER_WITH_CARD_AXEPTA" },
                    extra: {
                        idOrder: variables.idOrder,
                        context: "Error while paying order with credit card via Axepta",
                    },
                });
                return Promise.reject(new domain_1.PaymentServiceErrors.PayOrderWithCardError("PAY_ORDER_WITH_CARD_AXEPTA_FAILED", error));
            }
        });
    }
}
exports.FPaymentsService = FPaymentsService;
